<template>
  <!-- Header -->
  <div class="sorter-header">
    <div class="sorter-header__icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l182.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-118.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-32-80C127.5 19.7 99.3 0 66.5 0S5.5 19.7-6.8 48L32 48C14.3 48 0 62.3 0 80s14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 112c17.7 0 32-14.3 32-32s-14.3-32-32-32L233.3 48c-12.3-28.3-40.5-48-73.3-48z"/></svg>
    </div>
    <div class="sorter-header__text">
      <h2 class="sorter-title">Urutkan Preferensi Kamu</h2>
      <p class="sorter-subtitle">
        <em><i>Drag &amp; drop</i></em> dari yang <strong>paling menggambarkan dirimu</strong> (nomor 1) ke yang paling kurang.
      </p>
    </div>
  </div>

  <!-- Hint bar -->
  <!-- <div class="sorter-hint">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M32 448c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-576 0c-17.7 0-32 14.3-32 32l0 48zM48 64c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l544 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L48 64z"/></svg>
    Seret tiap baris untuk mengubah urutannya
  </div> -->

  <draggable
    v-model="sortedList"
    item-key="code"
    class="draggable-list"
    ghost-class="ghost"
  >
    <template #item="{ element, index }">
      <div
        class="list-item"
        :class="{
          'list-item--top': index === 0,
          'list-item--second': index === 1
        }"
      >
        <span class="item-rank" :class="`rank--${index}`">{{ index + 1 }}</span>
        <p class="item-text">{{ element.description }}</p>
        <span class="drag-handle" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zm192 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zm192 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0z"/></svg>
        </span>
      </div>
    </template>
  </draggable>
</template>

<script setup>
// [PERBAIKAN] Import 'computed' dan 'onMounted' dari vue
import {onMounted, computed } from 'vue';
import draggable from 'vuedraggable';

const props = defineProps({
  categories: { type: Object, required: true },
  modelValue: { type: Array, required: true }
});
const emit = defineEmits(['update:modelValue']);

const sortedList = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  }
});

onMounted(() => {
  if (!props.modelValue || props.modelValue.length === 0) {
    const initialList = Object.entries(props.categories).map(([code, description]) => ({ code, description }));
    emit('update:modelValue', initialList);
  }
});
</script>

<style scoped>
/* ---- Header ---- */
.sorter-header {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  padding: 1.25rem 1.5rem 1rem;
  background: linear-gradient(135deg, #EFF6FF, #f8faff);
  border-bottom: 1.5px solid #dce9f5;
  border-radius: 16px 16px 0 0;
}

.sorter-header__icon {
  width: 40px;
  height: 40px;
  background: #26488A;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.sorter-header__icon svg {
  width: 18px;
  height: 18px;
  fill: #F0D25B;
}

.sorter-header__text {
  flex: 1;
}

.sorter-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: #26488A;
  margin: 0 0 0.35rem;
  line-height: 1.2;
}

.sorter-subtitle {
  font-size: 0.8rem;
  color: #5a7a9a;
  margin: 0;
  line-height: 1.5;
}

.sorter-subtitle em   { color: #2980B9; font-style: normal; font-weight: 600; }
.sorter-subtitle strong { color: #26488A; }

/* ---- Hint bar ---- */
.sorter-hint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.5rem;
  background: #fffbea;
  border-bottom: 1.5px solid #f0d25b55;
  font-size: 0.75rem;
  font-weight: 600;
  color: #a07c10;
}

.sorter-hint svg {
  width: 12px;
  height: 12px;
  fill: #F0D25B;
  flex-shrink: 0;
}

/* ---- Draggable list ---- */
.draggable-list {
  padding: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  background: #ffffff;
  border-radius: 0 0 16px 16px;
}

.list-item {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.8rem 1rem;
  background: #f8fafc;
  border: 1.5px solid #e0ecf8;
  border-radius: 12px;
  cursor: grab;
  transition: background 0.2s, box-shadow 0.2s, border-color 0.2s, transform 0.15s;
  box-shadow: 0 1px 4px rgba(38, 72, 138, 0.05);
}

.list-item:hover {
  border-color: #4489C6;
  background: #f0f7ff;
  box-shadow: 0 4px 14px rgba(68, 137, 198, 0.12);
  transform: translateY(-1px);
}

.list-item:active { cursor: grabbing; }

/* Top 2 highlights */
.list-item--top {
  border-color: #F0D25B;
  background: linear-gradient(135deg, #fffdf4, #fff8e0);
  box-shadow: 0 3px 12px rgba(240, 210, 91, 0.18);
}

.list-item--top:hover {
  border-color: #e0b800;
  background: linear-gradient(135deg, #fffbe8, #fff5c8);
}

.list-item--second {
  border-color: #c3d9f0;
  background: #EFF6FF;
}

/* ---- Rank badge ---- */
.item-rank {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 800;
  flex-shrink: 0;
  background: #dce9f5;
  color: #26488A;
  transition: background 0.2s, color 0.2s;
}

.rank--0 {
  background: #F0D25B;
  color: #5a3d00;
  box-shadow: 0 2px 6px rgba(240, 210, 91, 0.4);
}

.rank--1 {
  background: #d1e8fb;
  color: #1a5f9e;
}

.item-text {
  flex: 1;
  font-size: 0.88rem;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.45;
  margin: 0;
}

.list-item--top .item-text { font-weight: 600; color: #1a2e0d; }

/* ---- Drag handle ---- */
.drag-handle {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0.2rem;
  cursor: grab;
}

.drag-handle svg {
  width: 14px;
  height: 14px;
  fill: #bdc3c7;
  transition: fill 0.2s;
}

.list-item:hover .drag-handle svg { fill: #4489C6; }

/* ---- Ghost ---- */
.ghost {
  opacity: 0.45;
  background: #e3f0fb;
  border: 2px dashed #4489C6;
  border-radius: 12px;
}

/* ---- Mobile ---- */
@media (max-width: 480px) {
  .sorter-header {
    padding: 1rem;
  }
  .sorter-title {
    font-size: 0.95rem;
  }
  .sorter-subtitle {
    font-size: 0.7rem;
  }
  .item-text {
    font-size: 0.75rem;
  }
  .item-rank {
    width: 24px;
    height: 24px;
    font-size: 0.7rem;
  }
}
</style>